import React, { useEffect, useState } from 'react';
import { Image as ImageIcon } from 'lucide-react';

const PortfolioImage = ({ image, className = '' }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [image.src]);

  return (
    <div
      className={`relative isolate overflow-hidden bg-[#0d1514] ${className}`}
      style={{ aspectRatio: `${image.width} / ${image.height}` }}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-[radial-gradient(circle_at_top,rgba(0,255,209,0.12),transparent_48%),linear-gradient(145deg,#111918,#080b0b)] px-6 text-center">
        <div className="absolute inset-0 opacity-25 [background-image:linear-gradient(rgba(255,255,255,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:32px_32px]" />
        <ImageIcon className="relative h-8 w-8 text-[#00FFD1]" aria-hidden="true" />
        <p className="relative text-sm font-semibold text-white">{image.label}</p>
        <p className="relative max-w-full break-all font-mono text-[10px] text-white/42">
          {image.src.replace('/images/work/', '')}
        </p>
        <span className="relative text-[10px] uppercase tracking-[0.18em] text-white/28">
          Screenshot placeholder · {image.width} × {image.height}
        </span>
      </div>

      {!hasError && (
        <img
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          loading="lazy"
          decoding="async"
          onError={() => setHasError(true)}
          className="absolute inset-0 h-full w-full object-cover"
        />
      )}

    </div>
  );
};

export default PortfolioImage;
